import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon
} from 'react-share';
import { isFirefox } from '@widergy/web-utils/lib/browser';

import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';
import { actionCreators as tipActions, tipPropTypes } from 'redux/tipHandlers';
import { socialButtonIconSize } from 'constants/sizes';

import shareIcon from '../../../../../../assets/ic_share.png';

import styles from './styles';

let shareUrl = '';

const buttons = [
  {
    id: 1,
    Icon: FacebookIcon,
    ShareButton: FacebookShareButton,
    show: true
  },
  {
    id: 2,
    Icon: TwitterIcon,
    ShareButton: TwitterShareButton,
    show: true
  },
  {
    id: 3,
    Icon: TelegramIcon,
    ShareButton: TelegramShareButton,
    show: true
  },
  {
    id: 4,
    Icon: WhatsappIcon,
    ShareButton: WhatsappShareButton,
    show: !isFirefox()
  }
];

class ShareLinksDropDown extends Component {
  state = { showShareLinksDropDown: false };

  componentWillMount() {
    document.addEventListener('click', this.handleShouldCloseDropdownShareLinks);
    shareUrl = document.URL;
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleShouldCloseDropdownShareLinks);
  }

  onClick = () => this.setState({ showShareLinksDropDown: !this.state.showShareLinksDropDown });

  onShareClick = () => this.props.dispatch(tipActions.tipShare(this.props.rowData));

  setContainerElem = shareLinksDropdown => (this.shareLinksDropdown = shareLinksDropdown);

  handleShouldCloseDropdownShareLinks = event => {
    if (!this.state.showShareLinksDropDown) return;
    if (this.shareLinksDropdown && !this.shareLinksDropdown.contains(event.target)) {
      this.setState({
        showShareLinksDropDown: false
      });
    }
  };

  render() {
    return (
      <div style={styles.container}>
        <UTTouchableWithoutFeedback
          onClick={this.onClick}
          style={styles.button}
          containerSetter={this.setContainerElem}
        >
          <img src={shareIcon} alt="Share" />
          {this.state.showShareLinksDropDown && buttons.length ? (
            <div style={styles.containerShow}>
              {buttons
                .filter(button => button.show)
                .map(({ id, Icon, ShareButton }) => (
                  <ShareButton
                    url={shareUrl}
                    title={this.props.rowData.description}
                    key={id}
                    beforeOnClick={this.onShareClick}
                  >
                    <Icon size={socialButtonIconSize} round />
                  </ShareButton>
                ))}
            </div>
          ) : (
            <div style={styles.containerHidden} />
          )}
        </UTTouchableWithoutFeedback>
      </div>
    );
  }
}

ShareLinksDropDown.propTypes = {
  rowData: PropTypes.shape(tipPropTypes).isRequired
};

export default connect()(ShareLinksDropDown);
